import AppConstants from '../config/app.constants';

let PricePointService = function ($http, $q) {

    let all = (offset, limit, sortingKey, sortingDir) => {
        return $http
            .get(AppConstants.api + `/price-point`, {
                params: {
                    offset,
                    limit,
                    sortingKey,
                    sortingDir,
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/price-point`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/price-point/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/price-point/${id}`, data)
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        get,
        update,
    };

};

PricePointService.$inject = ['$http', '$q']

export default PricePointService;


// WEBPACK FOOTER //
// ./client/app/services/price-point.service.js